import { motion } from "framer-motion";

const About = () => {
  return (
    <section id="sobre" className="section-padding">
      <div className="container-narrow">
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block text-sm font-medium text-primary uppercase tracking-wider mb-4">
              Sobre nós
            </span>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-8">
              Feito com amor, ponto a ponto
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative"
          >
            {/* Decorative quote marks */}
            <span className="absolute -top-8 left-0 text-8xl text-primary/10 font-display">
              "
            </span>

            <p className="text-lg md:text-xl text-foreground/80 leading-relaxed mb-6">
              A Solar Crocheteria nasceu do amor pelo crochê artesanal e pela beleza
              das peças feitas à mão. Cada criação carrega tempo, cuidado e atenção
              aos detalhes.
            </p>

            <p className="text-lg md:text-xl text-foreground/80 leading-relaxed">
              Não é apenas roupa — é trabalho artesanal transformado em estilo.
              É a certeza de vestir algo único, feito especialmente para quem
              valoriza a autenticidade.
            </p>

            <span className="absolute -bottom-8 right-0 text-8xl text-primary/10 font-display rotate-180">
              "
            </span>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-12"
          >
            <div className="decoration-line max-w-xs mx-auto" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
